"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewBundle = function NewBundle() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24\n0 18.6274 0 12Z",
    fill: "#157B3E"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#157B3E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.57499 19.9614L8.00767 13.7923L3.22119 9.64423L9.53652 9.09618L11.9999 3.27893L14.4634\n9.09618L20.7787 9.64423L15.9922 13.7923L17.4249 19.9614L11.9999 16.6884L6.57499 19.9614Z",
    fill: "white"
  }));
};
var _default = NewBundle;
exports.default = _default;